import React from "react";
import { useConsent, useGame, useGlobal, usePlayer, usePlayerID, useRound, useStage, } from "../hooks";
import { isDevelopment } from "../utils/debug";
import { Consent } from "./Consent";
import { Loading } from "./Loading";
import { Lobby as DefaultLobby } from "./Lobby";
import { PlayerID } from "./PlayerID";
import { Steps } from "./Steps";
export function GameFrame({ children, noGames: NoGames = DefaultNoGames, lobby = DefaultLobby, playerIDForm: PlayerIDForm = PlayerID, consent: ConsentComp = Consent, introSteps = [], exitSteps = [], }) {
    const { experimentOpen } = useGlobal();
    const player = usePlayer();
    const game = useGame();
    const [hasPlayer, onPlayerID] = usePlayerID();
    const [consented, onConsent] = useConsent();
    if (!game && !experimentOpen) {
        return React.createElement(NoGames, null);
    }
    if (!consented) {
        return React.createElement(ConsentComp, { onConsent: onConsent });
    }
    if (!hasPlayer && onPlayerID) {
        return React.createElement(PlayerIDForm, { onPlayerID: onPlayerID });
    }
    if (!player) {
        return React.createElement(Loading, null);
    }
    return (React.createElement(Steps, { progressKey: "intro", doneKey: "introDone", steps: introSteps },
        React.createElement(PostIntro, { exitSteps: exitSteps, lobby: lobby }, children)));
}
export function PostIntro({ children, lobby: Lobby, exitSteps, }) {
    const game = useGame();
    const stage = useStage();
    const round = useRound();
    if (!game) {
        return React.createElement(Lobby, null);
    }
    if (!stage || !round) {
        return React.createElement(Loading, null);
    }
    if (game.state == "ended") {
        return (React.createElement(Steps, { progressKey: "exitStep", doneKey: "exitStepDone", steps: exitSteps },
            React.createElement(Finished, null)));
    }
    return React.createElement(React.Fragment, null, children);
}
export function Finished() {
    return (React.createElement("div", { className: "h-full flex flex-col items-center justify-center" },
        React.createElement("h2", { className: "font-medium text-gray-700" }, "Finished"),
        React.createElement("p", { className: "mt-2 text-gray-400" }, "Thank you for participating")));
}
export function DefaultNoGames() {
    return (React.createElement("div", { className: "h-screen flex items-center justify-center" },
        React.createElement("div", { className: "w-92 flex flex-col items-center" },
            React.createElement("h2", { className: "text-gray-700 font-medium" }, "No experiments available"),
            React.createElement("p", { className: "mt-2 text-gray-400 text-justify" }, "There are currently no available experiments. Please wait until an experiment becomes available or come back at a later date."),
            isDevelopment ? (React.createElement("p", { className: "mt-4 text-gray-700" },
                "Go to",
                " ",
                React.createElement("a", { href: "/admin", target: "empirica-admin", className: "text-empirica-500" }, "Admin"),
                " ",
                "to get started")) : (""))));
}
